/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Nav_P_ApprovalInputs */

const en_mk_nav_p_approval = /** @type {(inputs: Mk_Nav_P_ApprovalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approvals`)
};

const id_mk_nav_p_approval = /** @type {(inputs: Mk_Nav_P_ApprovalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approval`)
};

/**
* | output |
* | --- |
* | "Approvals" |
*
* @param {Mk_Nav_P_ApprovalInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_nav_p_approval = /** @type {((inputs?: Mk_Nav_P_ApprovalInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Nav_P_ApprovalInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_nav_p_approval(inputs)
	return en_mk_nav_p_approval(inputs)
});